import styled from '@emotion/styled'
import { Button } from '../buttons/Button/Button'
import { calcRem, colors, fonts, themedValue } from '../__styling'

export const StyledNewsletterSubscription = styled('form')(() => ({
    maxWidth: calcRem(375),
}))

export const StyledHeading = styled('h1')(({ theme }) => ({
    fontFamily: themedValue(theme, {
        perthnow: fonts.perthnow.sansSerifCond,
        thewest: fonts.thewest.sansSerifCond,
        sevennews: fonts.sevennews.sansSerifCond,
    }),
    textTransform: 'uppercase',
    marginBottom: 0,
    lineHeight: 1,
}))

export const StyledBody = styled('p')(() => ({
    fontSize: calcRem(14),
}))

export const StyledLabel = styled('label')(({ theme }) => ({
    fontFamily: themedValue(theme, {
        perthnow: fonts.perthnow.sansSerif,
        thewest: fonts.thewest.sansSerif,
        sevennews: fonts.sevennews.sansSerif,
    }),
}))

export const StyledInput = styled('input')(({ theme }) => ({
    display: 'block',
    borderRadius: 2,
    border: `1px solid ${colors.thewest.greyQuokka}`,
    padding: calcRem(11, 12),
    margin: calcRem(5, 0, 10),
    width: '100%',
    fontFamily: themedValue(theme, {
        perthnow: fonts.perthnow.sansSerif,
        thewest: fonts.thewest.sansSerif,
        sevennews: fonts.sevennews.sansSerif,
    }),
}))

export const StyledTerms = styled('p')(() => ({
    fontSize: calcRem(14),
}))

export const StyledError = styled('p')(({ theme }) => ({
    fontSize: calcRem(14),
    color: themedValue(theme, {
        thewest: colors.thewest.engineRed,
        perthnow: colors.perthnow.redRuby,
        sevennews: colors.sevennews.red,
    }),
}))

export const StyledButton = styled(Button)(() => ({
    width: '100%',
}))
